export default __webpack_public_path__ + "static/blob3-e17a89508fd7bdaffa3b56c2ba7e1d7d.svg";